// Core
import React, { useState, useEffect } from "react";

//Redux
import { useDispatch } from "react-redux";
import { fetchMiningSpeakBearingList } from "../../../Redux/Slices/miningKgSlice";

//Import Scss
import "./styles.scss";

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from "../../Common/DatePicker";
import "react-datepicker/dist/react-datepicker.css";

const SpeakBearing = () => {
    const dispatch = useDispatch();
    const [speakBearingList, setSpeakBearingList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleFromDate = (date) => {
        setFromDate(date ? new Date(date) : null)
        if (toDate && date && toDate < date) {
            setToDate(null);
        }
    };
    const handleToDate = (date) => {
        setToDate(date ? new Date(date) : null);
    };

    const headerDetails = [
        { label: "S No", sortKey: false },
        {
            label: "Name",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "name" });
            },
        },
        {
            label: "Phone Number",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "phoneNumber" });
            },
        },
        {
            label: "Email",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "email" });
            },
        },
        {
            label: "Bearing Category",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "category" });
            },
        },
        { label: "Message", sortKey: true },
        {
            label: "Submitted On",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "createdAt" });
            },
        },
    ];

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    function formatSendDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate === "1970-01-01" ? null : formattedDate;
    }

    useEffect(() => {
        setIsLoading(true);
        dispatch(
            fetchMiningSpeakBearingList({
                data: {
                    page: currentPage,
                    limit: "10",
                    search: search,
                    sort_by: sortOptions.sort_by ? "ASC" : "DESC",
                    order_by: sortOptions.order_by,
                    fromDate: formatSendDate(fromDate) || "",
                    ...(formatSendDate(toDate) && { toDate: formatSendDate(toDate) }),
                },
                callBack: (value) => {
                    setSpeakBearingList(value?.data?.data_list || []);
                    setTotalPages(value?.data?.pageMeta?.totalPages || 1);
                    setTotalCount(value?.data?.pageMeta?.total || 0);
                    setIsLoading(false);
                },
            })
        );
    }, [dispatch, currentPage, search, sortOptions, fromDate, toDate]);

    const getInitials = (name) => {
        if (!name) return "";
        const [firstName = "", lastName = ""] = name.split(" ");
        return (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase();
    };

    return (
        <div className="speakBearingContainer">
            <div className="speakBearingHeader">
                <p></p>
                <div className="speakBearingDatePicker">
                    <p className="totalCount">
  Total count : {totalCount}
</p>
                    <input
                        type="text"
                        placeholder="Search by name, email, or category"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="searchInput"
                    />
                    <DatePicker
                        placeholderText="From Date"
                        selected={fromDate}
                        onChange={handleFromDate}
                        format={"dd-MM-yyyy"}
                        width='14vw'
                        height='6.5vh'
                    />
                    <DatePicker
                        placeholderText="To Date"
                        selected={toDate}
                        minDate={fromDate}
                        onChange={handleToDate}
                        format={"dd-MM-yyyy"}
                        width='14vw'
                        height='6.5vh'
                    />
                </div>
            </div>
            <div className="contactTableContainer">
                <NormalTable headerDetails={headerDetails}>
                    {speakBearingList.length > 0
                        ? speakBearingList.map((list, index) => {
                            const fullName = list.name || `${list.firstName || ""} ${list.lastName || ""}`.trim();

                            return (
                                <tr className="border" key={list.id}>
                                    <td style={{ paddingLeft: "18px" }}>
                                        {(currentPage - 1) * 10 + (index + 1)}
                                    </td>
                                    <td>
                                        <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
                                            {fullName ? (
                                                <div style={{ height: "30px", width: "30px", backgroundColor: "#1E2156", borderRadius: "50%", color: "white", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    {getInitials(fullName)}
                                                </div>
                                            ) : ""}
                                            <p>{fullName || "-"}</p>
                                        </div>
                                    </td>
                                    <td>{list?.phoneNumber || list?.contactNumber || "-"}</td>
                                    <td>{list?.email || "-"}</td>
                                    <td>{list?.category || "-"}</td>
                                    <td style={{ maxWidth: "250px" }}>{list?.message || "-"}</td>
                                    <td>{formatDate(list?.createdAt) || "-"}</td>
                                </tr>
                            );
                        })
                        : " "}
                </NormalTable>
                {speakBearingList.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh" }}>{isLoading ? "Loading" : "No Data Found"} </p>}
                {speakBearingList.length > 0 ?
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    /> : " "
                }
            </div>
        </div>
    );
};

export default SpeakBearing;
